/** 通用文案：语言切换、共享组件（@aitoken/ui）文案、状态名、时长单位。 */
const messages = {
  "language": "语言",
  "language.switch": "切换语言",
  "language.reviewNote": "",
  "close": "关闭",
  "copied": "已复制",
  "copyValue": "复制 {value}",
  "toggleSidebar": "展开/收起侧栏",
  "succeeded": "成功",
  "failed": "失败",
  "timelineSameId": "同一任务 ID · 全程不变",
  "site.cn": "国内站",
  "site.global": "海外站",
  "time.never": "从未",
  "duration.seconds": "{s} 秒",
  "duration.minutes": "{m} 分 {s} 秒",
  "duration.hours": "{h} 小时 {m} 分",
  "status.queued": "排队中",
  "status.preparing": "准备素材",
  "status.running": "生成中",
  "status.recovering": "恢复处理中",
  "status.reconciling": "核查中",
  "status.finalizing": "结算中",
  "status.succeeded": "成功",
  "status.failed": "失败",
  "status.cancelled": "已取消",
  "status.uploading": "上传中",
  "status.processing": "处理中",
  "status.available": "可用",
  "status.authorization_required": "需授权",
  "status.deleting": "删除中",
  "status.deleted": "已删除",
  "status.active": "启用",
  "status.disabled": "停用",
  "status.expired": "已过期",
  "status.revoked": "已撤销",
  "status.suspended": "已停用",
  "status.closed": "已关闭",
  "status.reserved": "已冻结",
  "status.pending_settlement": "待结算",
  "status.settled": "已结算",
  "status.released": "已释放",
  "status.waived": "已免单",
  "status.accrued": "待结算",
  "status.reversed": "已冲回",
  "status.pending": "处理中",
  "status.delivered": "已送达",
};

export default messages;
